export const FONT_FAMILY_OPTIONS = [{
  key: 'arial',
  label: __('Arial')
}, {
  key: 'courier new',
  label: __('Courier New')
}, {
  key: 'monospace',
  label: __('Monospace')
}, {
  key: 'serif',
  label: __('Serif')
}, {
  key: 'sans-serif',
  label: __('Sans-serif')
}];
export const HEADING_LEVEL_FONT_SIZES = ['2em', '1.5em', '1.17em', '1em', '.83em', '.67em'];
export const MENU_GROUP_TYPES = {
  UNDO_REDO: 'undo-redo',
  FONTS: 'fonts',
  TEXT_STYLES: 'text-styles',
  TEXT_HIGHLIGHTS: 'text-highlights',
  TEXT_ALIGNMENTS: 'text-alignments',
  INSERT: 'insert',
  CUSTOM: 'custom-blocks'
};
export const DEFAULT_ALLOWED_DOMAINS_FOR_MEDIA_UPLOAD = [/* Task Management */
'https://tap-document-mgmt-tap-production.s3.us-west-1.amazonaws.com',
// PROD
'https://gm-tap-document-mgmt-tap-prod.s3.us-west-1.amazonaws.com',
// PROD GM
'https://prod-tap-oem-document-mgmt.s3.us-west-1.amazonaws.com',
// PROD Asbury
'https://tap-document-mgmt-tap-stage.s3.us-west-1.amazonaws.com',
// STAGE
'https://gm-tap-document-mgmt-tap-stage.s3.us-west-1.amazonaws.com',
// STAGE GM
'https://tap-document-mgmt-tap-tst.s3.us-west-1.amazonaws.com',
// TST

/* CRM & Implementation */
'https://com-tekioncloud-tap-dealerscheduling.s3.us-west-1.amazonaws.com',
// PROD
'https://xyz-tekioncloud-tap-dealerscheduling.s3.us-west-1.amazonaws.com',
// STAGE
'https://xyz-tekion-tap-dealersignup.s3.us-west-1.amazonaws.com',
// TST
'https://tap-dealerscheduling.s3.us-west-1.amazonaws.com',
// DEV,

/* Support Portal */
'https://com-tekioncloud-tap-helpdesk-attachments.s3.us-west-2.amazonaws.com',
// PROD
'https://prod-tap-eu-helpdesk-attachments.s3.eu-west-3.amazonaws.com',
// PROD EU
'https://preprod-tap-helpdesk-attachments.s3.us-west-2.amazonaws.com',
// PREPROD
'https://preprod-tap-eu-helpdesk-attachments.s3.eu-west-3.amazonaws.com',
// PREPROD EU
'https://xyz-tekioncloud-tap-helpdesk-data.s3.us-west-2.amazonaws.com',
// STAGE
'https://tkdev-tap-helpdesk-attachments.s3.us-west-2.amazonaws.com',
// DEV
'https://xyz-tekion-tap-perf-helpdesk-attachment.s3.amazonaws.com',
// PERF
'https://xyz-tekion-tap-tst-helpdesk-attachments.s3.us-west-2.amazonaws.com' // TST
];